<script>
export default {
    data() {
        return {
            info: {
                name: '',
                contact: '',
                contactPhone: ''
            },
            error: {
                name: '',
                contact: '',
                contactPhone: ''
            }
        }
    },
    inject: [
        'totalReload'
    ],
    methods: {
        async confirm() {
            this.error.name = ''
            this.error.contact = ''
            this.error.contactPhone = ''
            let shouldBlock = false
            if (!this.info.name) {
                shouldBlock = true
                this.error.name = '请输入患者姓名'
            }
            if (!this.info.contact) {
                shouldBlock = true
                this.error.contact = '请输入联系人'
            }
            if (!/^1(3|5|7|8|9)\d{9}$/.test(this.info.contactPhone)) {
                shouldBlock = true
                this.error.contactPhone = '请输入正确的手机号'
            }
            if (shouldBlock) {
                return
            }
            let result = await this.$http.addAcount(this.info)
            if (result) {
                this.totalReload()
                this.$emit('close')
            }
        }
    }
}
</script>

<template>
    <Dialog btn-text="提交" title="添加账户" @confirm="confirm" @close="$emit('close')" >
        <DialogInput name="患者姓名" v-model="info.name" :error="error.name" />
        <DialogInput name="联系人" v-model="info.contact" :error="error.contact" />
        <DialogInput name="联系电话" v-model="info.contactPhone" :error="error.contactPhone" />
    </Dialog>
</template>

<style lang="scss" scoped>
.DialogInput {
    margin-left: 21px;
    margin-right: 21px;
}
</style>





// WEBPACK FOOTER //
// src/components/acount/AddAcountDialog.vue